import React from 'react';
import { ReactComponent as InfoIcon } from '../icons/icon_info_markets.svg';
import { getLabel } from '../data/labels';
import GobackButton from './GoBackButton';

export default function ErrorMessage(props) {
    return (
        <div className="xs_errorMessageContainer flex flex-col">
            <div className="xs_errorMessage h-20 mx-2 my-1 grid grid-cols-12 items-center bg-cs7 rounded">
                <InfoIcon className="col-start-1 col-end-3 h-16 w-16 fill-cs3" />
                <span className="col-start-3 col-end-13 font-medium text-md text-cs3">{props.message ? props.message : getLabel('general.error_fetching_data')}</span>
            </div>
            {!props.showBackButton &&
                <GobackButton />
            }
        </div>
    );
}
